/** @format */
import { smallMobile } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const styles = css`
    display: flex;
    width: 100%;
    align-items: stretch;
    justify-content: center;

    label.label,
    strong {
        ${theme.typography.body_normal_highlight};
    }

    span.text,
    button {
        ${theme.typography.body_normal};
    }

    ${smallMobile(css`
        label.label,
        strong {
            ${theme.typography.body_small};
        }

        span.text,
        button {
            ${theme.typography.body_small};
        }
    `)}

    .control-group-item {
        display: flex;
        flex-grow: 1;
        flex-basis: 0;
        align-items: center;
        justify-content: center;
        padding: var(--layout-spacing-16) var(--layout-spacing-4);
        white-space: pre;
        border: 1px solid var(--colors-border-light);
        border-right: none;

        &:first-child {
            border-left: none;
        }
    }

    button {
        flex-grow: 1;
        border: none;
        background: none;
        cursor: pointer;
        padding: 0;
        font-weight: unset;
    }
`;
